import React from "react";
import { IState } from "../../../../common/state/IState";
import { useSelector } from "react-redux";
import { ErrorMarkIconComponent } from "../../../../common/icons/ErrorMarkIconComponent";

const selector = (state: IState) =>
    state?.userManagement?.subscriptionPreferences?.updateErrors?.consent;

export function GlobalConsentsErrorElement({ className }) {
    const error = useSelector(selector);

    return error ? (
        <div className={className}>
            <ErrorMarkIconComponent />
            Unsaved consents. Please try again later.
        </div>
    ) : null;
}